import { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import useQueryString from './../../utils/hooks/useQueryString';
import { useQuery } from "@tanstack/react-query";
import Api from "utils/api/Api";


export const TopicHeader = ()=>{
    const { school, topicId } = useParams();
    const [ openGuide, setOpenGuide ] = useState(false);
    const { bestYn } = useQueryString();
    const auth = useSelector(state => state.auth);
    const queryParams = useQueryString();

    const { data:topic,  } = useQuery({
        queryKey:['donghwa/topic', topicId],
        queryFn:()=>Api.get(`/api/dongwha/topic/${topicId}`),
        staleTime: 1000 * 60 * 60,
    });
    
    const onToggleGuide = useCallback(() => {
        setOpenGuide(!openGuide);
    }, [openGuide]);

    return (
        <div className="topicHeader">
            <div className="visual">
                <div className="item_title">
                    <h2 className="title">동화서당</h2>
                    <p className="sub_title">훈장님의<br/><span>{topic?.data?.title}</span></p>
                    <button className="btn_guide" onClick={onToggleGuide}><i className="fa-solid fa-circle-question"></i>동화서당 참여하는 방법</button>
                    <div className="item_btn">
                        {   auth.authenticated &&
                            <>
                                {topic?.data?.completeYn === 'N' && <Link to={`/${school}/donghwa/${topic?.data?.id}/form`} className="btn _border _border_blue _square">글 작성하기</Link>}
                                {
                                    queryParams.user === 'Y' ? 
                                        <Link to={`/${school}/donghwa/${topic?.data?.id}`} className="btn _blue _square">전체작품</Link> :
                                        <Link to={`/${school}/donghwa/${topic?.data?.id}?user=Y`} className="btn _border _border_blue _square">내 작품</Link>
                                }
                            </>
                        }

                        { topic?.data?.completeYn === 'Y' && bestYn === 'Y' &&
                            <Link to={`/${school}/donghwa/${topic?.data?.id}`} className="btn _blue _square">전체작품</Link>}
                        { topic?.data?.completeYn === 'Y' && bestYn !== 'Y' &&
                            <Link to={`/${school}/donghwa/${topic?.data?.id}?bestYn=Y&size=16`} className="btn _border _border_blue _square">장원급제 작품 보기</Link>}
                    </div>
                </div>
                <div className="topic">
                    <div className="topic_item">
                        <h3 className="title">{topic?.data?.subTitle}</h3>
                        <div className="story">
                            {topic?.data?.content}
                        </div>
                    </div>
                </div>
            </div>
            {
                openGuide && 
                <div className="modal">
                    <div className="modal_cont">
                        <h4 className="title"><p><span>Q</span>동화 서당에 참여하는 방법이 궁금해요.</p></h4>
                            <div className="desc">
                                <div className="row">
                                    <p className="devision"><span>첫 번째</span>훈장 선생님이 제시한 글감을 읽는다.</p>
                                    <p className="txt">매달 훈장님이 재미있는 글감을 제시해주실 거예요. 글감을 읽어보아요.</p>
                                </div>
                                
                                <div className="row">
                                    <p className="devision"><span>두 번째</span>이야기의 뒷 내용을 상상하여 적는다.</p>
                                    <p className="txt">주어진 글감을 읽고, 상상의 나래를 펼쳐보세요. 나만의 이야기를  완성하면 여러분도 동화작가랍니다.</p>
                                </div>
                                
                                <div className="row">
                                    <p className="devision"><span>세 번째</span> 제출한 뒤, 훈장님의 답변을 기다린다.</p>
                                    <p className="txt">훈장님이 여러분의 작품을 읽고, 작품에 대한 의견과 함께, 글쓰기 실력 향상을 위한 조언도 해주실 거예요. <br />궁금한 점이 있으면 훈장님께 여쭤보고 여러 친구들과 의견을 나눠봐도 좋아요.</p>
                                </div>
                                
                                <p className="txt">참여한 어린이들은 <span>사과 하나</span>를 받을 수 있습니다.</p>
                                <p className="txt">진지한 태도로 임하지 않고 성의 없이 쓴 글은 <span>삭제</span>합니다. 사과도 받을 수 없습니다.</p>
                                <p className="txt">매달 훈장님이 우수한 작품을 쓴 어린이를 선발해 해당 어린이를 <span>장원급제자</span>로 임명합니다.</p>
                            </div>
                        <button className="btn _blue" onClick={onToggleGuide}>닫기</button>
                    </div>
                </div>
            }
        </div>
    )
};